import { Outlet } from "react-router";
import { Footer } from "components";
import { RootProps } from "routes";
import "./Layout.scss";
import Message from "components/Message";

export interface LayoutProps extends RootProps {}

const Layout = (props: LayoutProps) => {
  const { currentRoute } = props;
  const isModelRoute = currentRoute?.name === "Model";
  const layoutClassName = [
    currentRoute?.footer ? "layout" : "layout without-footer",
    isModelRoute ? "layout--fullwidth" : "",
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <div className={layoutClassName}>
      <Outlet />
      <Message />
      {currentRoute?.footer && <Footer {...props} />}
    </div>
  );
};

export default Layout;
